import { Toast } from 'antd-mobile';
import queryString from 'query-string';
// eslint-disable-next-line import/no-cycle
import { isServerSide } from '@/utils/payment';
import Cookies from 'js-cookie';

const apiUrl = process.env.NEXT_PUBLIC_COMMON_API_HOST;
export interface Config extends RequestInit {
  token?: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  data?: object;
  // 是否显示错误提醒 默认显示
  errorToast?: boolean;
  /**
   * 结果是否转为json
   */
  toJson?: boolean;
  needToken?: boolean;
}

const http = async <T>(
  endpoint: string,
  { data, token, headers, toJson = true, errorToast = true, ...customConfig }: Config = {},
): Promise<T> => {
  let authToken = token;

  const cookieToken = Cookies.get('token');

  if (cookieToken && !token) {
    authToken = cookieToken;
  }

  const config = {
    method: 'GET',
    headers: {
      Authorization: authToken ? `Bearer ${authToken}` : '',
      'Content-Type': data ? 'application/json' : '',
      ...headers,
    },
    ...customConfig,
  };

  if (config.method.toUpperCase() === 'GET') {
    if (data) {
      // eslint-disable-next-line no-param-reassign
      endpoint += `?${queryString.stringify(data)}`;
    }
  } else {
    config.body = JSON.stringify(data || {});
  }

  return fetch((endpoint.startsWith('http') && endpoint) || `${apiUrl}/${endpoint}`, config).then(async (response) => {
    if (response.ok) {
      if (toJson) {
        return <T>await response.json();
      }
      return <T>((await response.text()) as unknown);
    }
    const errorBody = <{ message: string; status: number }>await response.json();
    if (errorToast) {
      const errMessage = (errorBody && errorBody.message) || 'Request error!'!;

      // 判断浏览器环境
      if (!isServerSide()) {
        if (errMessage !== 'payment.pingpong.va.insufficient') {
          Toast.show({
            icon: 'fail',
            content: errMessage,
            duration: 2000,
          });
        }
      }
    }
    errorBody.status = response.status;
    return Promise.reject(errorBody);
  });
};
export { http };
